
import 'magnific-popup';
export default {
    init(el) {
        $(el).find('.gallery__entry').magnificPopup({
            type: 'image',
            gallery:{
                enabled:true
            }
        });
    }
}


